var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMenu = function SvgMenu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4.25h12.75v1.417H0V4.25Zm0 3.542h12.75v1.416H0V7.792Zm0 3.541h12.75v1.417H0v-1.417Z"
  })));
};
export { SvgMenu as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjIiIGhlaWdodD0iMjIiIHZpZXdCb3g9IjAgMCAxNyAxNyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiByb2xlPSJwcmVzZW50YXRpb24iIGFyaWEtaGlkZGVuPSJ0cnVlIj4KICAgIDxnIGlkPSJtZGk6aGFtYnVyZ2VyLW1lbnUiPgogICAgPHBhdGggaWQ9IlZlY3RvciIgZD0iTTAgNC4yNUgxMi43NVY1LjY2NjY3SDBWNC4yNVpNMCA3Ljc5MTY3SDEyLjc1VjkuMjA4MzNIMFY3Ljc5MTY3Wk0wIDExLjMzMzNIMTIuNzVWMTIuNzVIMFYxMS4zMzMzWiIvPgogICAgPC9nPgo8L3N2Zz4=";